let colors = {
	primary : '#1e3d73'
}
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
let theme = getParameterByName('theme');
let rtl = getParameterByName('rtl');



const themeConfig = {
  settingpanel : true, 
  rtl               : rtl || false,
  compactsidebar  : false,
  theme             :theme || "light",
  menulayout : "vertical"
}

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })

export default themeConfig
